var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6904 2C7.16797 2 2.69043 6.48 2.69043 12C2.69043 17.52 7.16797 22 12.6904 22C18.2129 22 22.6904 17.52 22.6904 12C22.6904 6.48 18.2129 2 12.6904 2ZM12.6904 20C8.27793 20 4.69043 16.41 4.69043 12C4.69043 7.59 8.27793 4 12.6904 4C17.1029 4 20.6904 7.59 20.6904 12C20.6904 16.41 17.1029 20 12.6904 20ZM13.1904 7H11.6904V13L16.8904 16.2L17.6904 14.9L13.1904 12.2V7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.773d1969b10fab1d248d56708679fb68.svg";
export { ForwardRef as ReactComponent };